import hero from "./assets/bmfHero.png"


export const BetterMobilityData = {
    title: "Better Mobility Forum: Strategizing a Public Platform for Sri Lanka's Transport Policy",
    heroImage: hero,
    thumbnailImage:hero
}